export const messagesData = [
  {
    id: 1,
    sender: {
      name: "BrightWay Support",
      avatar: "/logo/brightwaylogo.png",
    },
    subject: "Welcome to BrightWay 🎉",
    preview: "Hello Nyeswa, welcome to BrightWay! Let’s help you set up your profile.",
    time: "2m ago",
    unread: false,
    fullText: `
      Hello Nyeswa,  

      Welcome to BrightWay! 🎉 We’re excited to have you join our community of learners, schools, and organizations.  

      Here are a few things you can do to get started:  
      - Complete your profile  
      - Connect with your school or workplace  
      - Explore scholarships, challenges, and opportunities  

      If you need help, just reply to this message.  
      
      — BrightWay Team
    `,
  },
  {
    id: 2,
    sender: {
      name: "John Doe",
      avatar: "https://media.licdn.com/dms/image/v2/D4D03AQHd6PJ9arawBQ/profile-displayphoto-shrink_800_800/B4DZVQVzt8G4Ac-/0/1740809651805?e=1762387200&v=beta&t=lICc77R-XsPcThTn1_xTtfD0h9G0R4-EMmwOA4ziE5I",
    },
    subject: "Study Group Invite",
    preview: "Hey, would you like to join our AI study group this weekend?",
    time: "10m ago",
    unread: true,
    fullText: `
      Hey Nyeswa,  

      A couple of us are putting together a study group for AI and Machine Learning.  
      We’ll meet online this weekend (Saturday at 4 PM).  

      It’ll be casual, we’ll discuss assignments and share resources.  
      Let me know if you’d like to join, I’ll send you the link.  

      — John
    `,
  },
  {
    id: 3,
    sender: {
      name: "Sarah Momo",
      avatar: "https://media.licdn.com/dms/image/v2/D4E03AQHcjPfTdNJ5sA/profile-displayphoto-shrink_800_800/B4EZYclDP5HMAc-/0/1744236197744?e=1762387200&v=beta&t=pqVRqb3LMwB_CS_r7aRyIFTB6rZf2X_iG60i_hwxL1A",
    },
    subject: "Scholarship Opportunity",
    preview: "Check out this new scholarship program I found, you might be interested!",
    time: "1h ago",
    unread: false,
    fullText: `
      Hi Nyeswa,  

      I came across this scholarship that supports students in computer science fields.  
      It’s called the “Future Innovators Scholarship 2025.”  

      Requirements:  
      - Must be enrolled in undergraduate program  
      - GPA above 3.0  
      - Short essay on innovation in education  

      Deadline: October 15, 2025.  

      Thought you might be interested!  
      — Mary
    `,
  },
  {
    id: 4,
    sender: {
      name: "Tech Club",
      avatar: "https://media.licdn.com/dms/image/v2/D4D03AQHLqNaMbaZbbQ/profile-displayphoto-shrink_800_800/B4DZkLdKOgGkAc-/0/1756833821552?e=1762387200&v=beta&t=j_SsiGKxpf-S_QLelj0dDVR4ixH_ffzJarSSWOFSMCs",
    },
    subject: "AI Innovation Challenge 🚀",
    preview: "We’re excited to announce the 2025 AI Challenge. Register today!",
    time: "3h ago",
    unread: false,
    fullText: `
      Hello Innovators,  

      The 2025 AI Innovation Challenge is officially open! 🚀  

      Teams of students, professionals, and enthusiasts can compete to build AI projects that solve real-world problems.  
      Categories include:  
      - Education  
      - Healthcare  
      - Environment  
      - Business  

      Prizes: Up to $10,000 in cash and mentorship opportunities.  

      Register by October 30, 2025.  
      — BrightWay Tech Club
    `,
  },
  {
    id: 5,
    sender: {
      name: "BrightWay Updates",
      avatar: "https://media.licdn.com/dms/image/v2/D4D03AQFIg0oPyzZNug/profile-displayphoto-shrink_800_800/B4DZfXYbyhHAAg-/0/1751665198626?e=1762387200&v=beta&t=GOWnY0yTJgCYfKobb8lOym2yWE0szV3t2L4fCbBi6UM",
    },
    subject: "New Feature: Study with AI",
    preview: "We’ve added a new way to study smarter with AI assistance.",
    time: "Yesterday",
    unread: false,
    fullText: `
      Hi Nyeswa,  

      Great news — we’ve launched a new feature called **Study with AI** 📚🤖  

      With this tool, you can:  
      - Get instant explanations for difficult concepts  
      - Generate practice questions  
      - Summarize long study notes  

      Try it today from your dashboard under “Academics.”  

      — The BrightWay Team
    `,
  },
];
